
import { css } from "@emotion/react"
import { Button } from "component"
import { TextField } from "component/TextField"
import { ChangeEventHandler, MouseEventHandler } from "react"
import { BiComment } from "react-icons/bi"

type Props = {
  onChange: ChangeEventHandler
  onUpdateClick: MouseEventHandler
}

export const ChangeMessage = (props: Props) =>{

  return(
    <div css={changeMessageContainerCss}>
      <TextField
        icon={<BiComment/>}
        placeholder="更新後"
        onChange={props.onChange}
      />
      <div css={buttonContainerCss}>
        <Button onClick={props.onUpdateClick}>更新する</Button>
      </div>
    </div>
  )
}

const changeMessageContainerCss=  css`
  padding: 1rem;
`

const buttonContainerCss=css`
  display: flex;
  justify-content: center;
`